import React from 'react';
import c from 'classnames';

import { RecursiveMenu } from '@uncinc/react-drupal-core';

import './style.scss';

export interface HeroCtaMenuProps {
  className?: string;
}

const HeroCtaMenu: React.FC<HeroCtaMenuProps> = (props) => {
  const { className } = props;

  const classNames = c('HeroCtaMenu', className);

  return (
    <RecursiveMenu
      menuId="hero-cta-menu"
      className={classNames}
    />
  );
};

export default HeroCtaMenu;
